import { Box } from '@mui/material';
import { MembersCountBox } from '../../../shared/members-count-box';

import ArrowRight from 'assets/icons/buttons/right-arrow.svg';
import { IMembersButton } from './types';
import { styles } from './styles';

export const MembersButton = ({ count, onClick }: IMembersButton) => {
  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      sx={styles.container}
    >
      <MembersCountBox count={count} />
      <ArrowRight />
    </Box>
  );
};
